import { Dialog, FormControl, IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import IntlMessages from 'Util/IntlMessages';
import React, { useEffect, useMemo, useState } from 'react';
import icClose from 'Assets/img/recruitment/ic_close.png';
import icClose2 from 'Assets/img/recruitment/ic_close@2x.png';
import icClose3 from 'Assets/img/recruitment/ic_close@3x.png';
import icVisibility from 'Assets/img/recruitment/ic_visibility.png';
import icVisibility2 from 'Assets/img/recruitment/ic_visibility@2x.png';
import icVisibility3 from 'Assets/img/recruitment/ic_visibility@3x.png';
import icVisibilityOff from 'Assets/img/recruitment/ic_visibility_off.png';
import icVisibilityOff2 from 'Assets/img/recruitment/ic_visibility_off@2x.png';
import icVisibilityOff3 from 'Assets/img/recruitment/ic_visibility_off@3x.png';
import icCheckFalse from 'Assets/img/recruitment/ic_check_false.png';
import icCheckFalse2 from 'Assets/img/recruitment/ic_check_false@2x.png';
import icCheckFalse3 from 'Assets/img/recruitment/ic_check_false@3x.png';
import icCheckTrue from 'Assets/img/recruitment/ic_check_true.png';
import icCheckTrue2 from 'Assets/img/recruitment/ic_check_true@2x.png';
import icCheckTrue3 from 'Assets/img/recruitment/ic_check_true@3x.png';
import icArrowGray from 'Assets/img/recruitment/ic_arrow_gray.png';
import icArrowGray2 from 'Assets/img/recruitment/ic_arrow_gray@2x.png';
import icArrowGray3 from 'Assets/img/recruitment/ic_arrow_gray@3x.png';
import { getImageSet, getOnlyNumber } from 'Util/DataUtils';
import { useIntl } from 'react-intl';
import CancelIcon from '@mui/icons-material/Cancel';
import EndPoint from 'Api/EndPoint';
import { joinError, defaultError } from 'Api/Errors';
import LoadingView from 'Components/common/LoadingView';
import { joinFromTeamRecruitment } from 'Api/endpoints/Auth';
import CommonPopup from 'Components/Popup/CommonPopup';
import { useSelector } from 'react-redux';
import { useError } from 'Api/hooks/useError';

const DEBUG = import.meta.env.DEV;
const PASSWORD_REGEX = /^.{8,12}$/;
const customFieldStyle = {
  '& .MuiOutlinedInput-root': {
    fieldset: {
      border: '1px solid #C4C4C4',
    },
    '&:hover fieldset': {
      borderColor: '#C4C4C4',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #C4C4C4',
    },
    '&.Mui-error fieldset': {
      border: '1px solid #f00',
    },
  },
};
const customFieldInputStyle = {
  padding: '12px 10px',
  borderRadius: '6px',
  fontSize: '16px',
  fontFamily: 'Pretendard',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
};
const closeButtons = getImageSet([icClose, icClose2, icClose3]);
const visibility = getImageSet([icVisibility, icVisibility2, icVisibility3]);
const visibilityOff = getImageSet([icVisibilityOff, icVisibilityOff2, icVisibilityOff3]);
const checkFalseSet = getImageSet([icCheckFalse, icCheckFalse2, icCheckFalse3]);
const checkTrueSet = getImageSet([icCheckTrue, icCheckTrue2, icCheckTrue3]);
const arrowSet = getImageSet([icArrowGray, icArrowGray2, icArrowGray3]);

const JoinPopup = ({ open, onClose, onConfirm }) => {
  const { formatMessage } = useIntl();
  const [account, setAccount] = useState({
    phone: '',
    password: '',
    password2: '',
    companyName: '',
    referral: '',
    agreePrivacyUsage: false,
    agreeMarketing: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { locale } = useSelector(state => state.settings.locale);
  const { showErrorPopup } = useError();

  useEffect(() => {
    if (open) {
      setAccount({
        phone: '',
        password: '',
        password2: '',
        companyName: '',
        referral: '',
        agreePrivacyUsage: false,
        agreeMarketing: false,
      });
      setShowPassword(false);
      setShowPassword2(false);
      setErrorMessage('');
      setLoading(false);
      setIsSuccess(false);
    }
  }, [open]);

  const openPolicy = () => {
    const width = window.outerWidth / 1.5;
    const height = window.outerHeight / 1.5;
    const left = window.screenX + window.outerWidth / 6;
    const top = window.screenY + window.outerHeight / 6;
    window.open(
      `${EndPoint.HostRoot}/terms/${locale}/t3/`,
      'Policy',
      `location=no,toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no,width=${width}px,height=${height}px,top=${top}px,left=${left}px`
    );
  };

  const onChange = ({ target: { name, value: prevValue } }) => {
    let value = prevValue;
    if (name === 'phone') {
      value = getOnlyNumber(prevValue);
    }
    setAccount(x => ({
      ...x,
      [name]: value,
    }));
  };

  const isEmpty = useMemo(() => {
    const { name, phone, password, password2, companyName } = account;
    if (name === '' || phone === '' || password === '' || password2 === '' || companyName === '') return true;
  }, [account]);

  const onClickJoin = async () => {
    const { phone, password, password2, companyName, agreePrivacyUsage, agreeMarketing, referral } = account;
    if (isEmpty) {
      setErrorMessage('empty');
      return;
    } else if (isInvalidPassword) {
      setErrorMessage('invalidPassword');
      return;
    } else if (password !== password2) {
      setErrorMessage('isNotSamePassword');
      return;
    } else if (!agreePrivacyUsage) {
      setErrorMessage('agreePrivacyUsage');
      return;
    }
    try {
      setLoading(true);
      const result = await joinFromTeamRecruitment({
        isTester: DEBUG ? true : false,
        phoneCountry: '82',
        businessNumber: phone,
        password,
        companyName,
        agreePrivacyUsage,
        agreeMarketing,
        ...(referral && { referral }),
      });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      onClose();
      setIsSuccess(true);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const isInvalidPassword = useMemo(() => {
    const { password } = account;
    return !PASSWORD_REGEX.test(password);
  }, [account]);

  const getErrorMessage = () => {
    if (errorMessage === 'empty') return formatMessage({ id: 'recruitment.join.error.empty' });
    if (errorMessage === 'invalidPassword') return formatMessage({ id: 'recruitment.join.error.invalidPassword' });
    if (errorMessage === 'isNotSamePassword') return formatMessage({ id: 'recruitment.join.error.isNotSamePassword' });
    if (errorMessage === 'agreePrivacyUsage') return formatMessage({ id: 'recruitment.join.error.agreePrivacyUsage' });
    if (!joinError[errorMessage]) return formatMessage({ id: defaultError });
    return formatMessage({ id: joinError[errorMessage] });
  };

  return (
    <>
      <Dialog fullWidth={true} maxWidth="basic" onClose={null} open={open}>
        <div className="recruitment-join-popup">
          <div className="recruitment-join-popup-header">
            <div style={{ width: '32px' }} />
            <div className="header-title">
              <IntlMessages id="sign.join" />
            </div>
            <div className="close-button">
              <img {...closeButtons} alt="close" onClick={onClose} />
            </div>
          </div>
          <div className="recruitment-join-popup-body">
            <div className="recruitment-join-popup-input-wrapper">
              <div className="recruitment-join-popup-input-title">
                <IntlMessages id="common.id" />
              </div>
              <FormControl className="id-input-wrapper" sx={customFieldStyle}>
                <OutlinedInput
                  name="phone"
                  value={account.phone}
                  onChange={onChange}
                  type="text"
                  variant="outlined"
                  placeholder={formatMessage({ id: 'recruitment.phone.placeholder' })}
                  inputProps={{ style: customFieldInputStyle, tabIndex: '1' }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={() => onChange({ target: { name: 'phone', value: '' } })} edge="end">
                        {<CancelIcon sx={{ color: '#7a7a7a', fontSize: 24 }} />}
                      </IconButton>
                    </InputAdornment>
                  }
                  autoFocus
                />
              </FormControl>
            </div>
            <div className="recruitment-join-popup-input-wrapper">
              <div className="recruitment-join-popup-input-title">
                <IntlMessages id="recruitment.companyName" />
              </div>
              <div className="company-input-wrapper">
                <input type="text" value={account.companyName} name="companyName" onChange={onChange} placeholder={formatMessage({ id: 'recruitment.companyName' })} tabIndex="2" />
              </div>
            </div>
            <div className="recruitment-join-popup-input-wrapper">
              <div className="recruitment-join-popup-input-title">
                <IntlMessages id="common.password" />
              </div>
              <FormControl className="password-input-wrapper" sx={customFieldStyle}>
                <OutlinedInput
                  autoComplete="new-password"
                  name="password"
                  value={account.password}
                  onChange={onChange}
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  placeholder={formatMessage({ id: 'common.password' })}
                  inputProps={{ style: customFieldInputStyle, tabIndex: '3' }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword(x => !x)} edge="end">
                        {showPassword ? <img {...visibilityOff} alt="visibilityOff" /> : <img {...visibility} alt="visibility" />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className="recruitment-join-popup-input-wrapper">
              <div className="recruitment-join-popup-input-title">
                <IntlMessages id="common.password2" />
              </div>
              <FormControl className="password-input-wrapper" sx={customFieldStyle}>
                <OutlinedInput
                  autoComplete="new-password"
                  name="password2"
                  value={account.password2}
                  onChange={onChange}
                  type={showPassword2 ? 'text' : 'password'}
                  variant="outlined"
                  placeholder={formatMessage({ id: 'common.password2' })}
                  inputProps={{ style: customFieldInputStyle, tabIndex: '4' }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" onClick={() => setShowPassword2(x => !x)} edge="end">
                        {showPassword2 ? <img {...visibilityOff} alt="visibilityOff" /> : <img {...visibility} alt="visibility" />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className="recruitment-join-popup-input-wrapper">
              <div className="recruitment-join-popup-input-title">
                <IntlMessages id="recruitment.referral" />
              </div>
              <div className="company-input-wrapper">
                <input type="text" value={account.referral} name="referral" onChange={onChange} placeholder={formatMessage({ id: 'recruitment.referral.placeholder' })} tabIndex="5" />
              </div>
            </div>
            <div className="policy-wrapper">
              <div className="policy-title">
                <IntlMessages id="recruitment.policy.title" />
              </div>
              <div className="policy-input-wrapper">
                <div className="policy-contents-wrapper">
                  <div className="policy-left">
                    <div className="policy-check" onClick={() => onChange({ target: { name: 'agreePrivacyUsage', value: !account.agreePrivacyUsage } })}>
                      {account.agreePrivacyUsage ? <img {...checkTrueSet} alt="agreePrivacyUsage_true" /> : <img {...checkFalseSet} alt="agreePrivacyUsage_false" />}
                    </div>
                    <div onClick={() => onChange({ target: { name: 'agreePrivacyUsage', value: !account.agreePrivacyUsage } })} className="policy-contents">
                      <IntlMessages id="recruitment.policy.1" />
                    </div>
                  </div>
                  <div className="policy-detail" onClick={openPolicy}>
                    <img {...arrowSet} alt="arrow" />
                  </div>
                </div>
              </div>
            </div>
            {errorMessage && <div className="error-view">{getErrorMessage()}</div>}
            <div className="join-button-wrapper">
              <div className="join-button" onClick={onClickJoin}>
                <IntlMessages id="recruitment.join" />
              </div>
            </div>
          </div>
        </div>
        <LoadingView isLoading={loading} />
      </Dialog>
      <CommonPopup
        show={isSuccess}
        needIntl
        title="recruitment.join.confirm"
        imageType="su"
        onClose={() => {
          setIsSuccess(false);
          onConfirm();
        }}
        cancelText="button.confirm"
      />
    </>
  );
};

export default JoinPopup;
